<template>
  <div>
    <ExecutingCourseTree
      v-if="
        !executingCourse.course.loading &&
          executingCourse.course.tree &&
          !(executingCourse.activeElement.loading || executingCourse.activeElement.item)
      "
      :tree="executingCourse.course.tree"
      :finished="finished"
      @refreshTree="refreshTree"
    />
    <v-container v-else-if="!activeElement">
      <v-row justify="center">
        <v-col cols="8">
          <v-card min-height="600">
            <v-skeleton-loader type="image" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <router-view></router-view>
  </div>
</template>

<script>
import ExecutingCourseTree from '@/components/course/ExecutingCourseTree.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapActions, mapState, mapGetters } = createNamespacedHelpers('courseExecution');

export default {
  components: {
    ExecutingCourseTree
  },
  computed: {
    ...mapState({
      executingCourse: 'executingCourse',
      activeElement: state => state.executingCourse.activeElement.item
    }),
    ...mapGetters(['activeExecutionCourseState']),
    finished() {
      return this.activeExecutionCourseState === 2;
    }
  },
  async mounted() {
    if (!this.executingCourse.course.loading && !this.executingCourse.course.item) {
      const result = await this.getCourseToExecute({
        courseId: Number(this.$route.params.courseId)
      });
      if (!result) {
        try {
          await this.$router.push('/');
        } catch (e) {
          // ignore error
        }
      }
    }
  },
  methods: {
    ...mapActions(['getCourseToExecute']),
    refreshTree() {
      this.getCourseToExecute({
        courseId: Number(this.$route.params.courseId)
      });
    }
  }
};
</script>
